"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelDownloadingErrorGrasshopper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function ModelDownloadingErrorGrasshopper() {
    const bridge = (0, bridge_1.useBridge)();
    const onRetry = () => {
        const redirectUrl = sessionStorage.getItem('nextUrl') || '/';
        window.location.href = window.location.origin + redirectUrl;
    };
    const onNeedAssistanceClick = () => {
        const supportHubLink = 'https://service.elsevier.com/app/home/supporthub/complete-anatomy/';
        bridge === null || bridge === void 0 ? void 0 : bridge.openURL({ link: supportHubLink });
    };
    return ((0, jsx_runtime_1.jsxs)(Content, { "data-e2e": 'ModelDownloadingErrorGrasshopper_Content', children: [(0, jsx_runtime_1.jsx)(ConnectionErrorIcon, { name: ui_1.Icons.Connection_Error, "data-e2e": 'ModelDownloadingErrorGrasshopper_ConnectionErrorIcon' }), (0, jsx_runtime_1.jsx)(Title, { "data-e2e": 'ModelDownloadingErrorGrasshopper_Title', children: (0, i18n_1.Localized)(i18n_1.Strings.popups.genericError.heading) }), (0, jsx_runtime_1.jsx)(SubTitle, { "data-e2e": 'ModelDownloadingErrorGrasshopper_SubTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.popups.genericError.text) }), (0, jsx_runtime_1.jsx)(ButtonContainer, { "data-e2e": 'ModelDownloadingErrorGrasshopper_ButtonContainer', children: (0, jsx_runtime_1.jsx)(RetryButton, { onClick: onRetry, "data-e2e": 'ModelDownloadingErrorGrasshopper_RetryButton', children: (0, i18n_1.Localized)(i18n_1.Strings.popups.genericError.retry) }) }), (0, jsx_runtime_1.jsx)(ui_1.FooterForGrasshopperErrorPage, { onClick: onNeedAssistanceClick, "data-e2e": 'ModelDownloadingErrorGrasshopper_FooterForGrasshopperErrorPage' })] }));
}
exports.ModelDownloadingErrorGrasshopper = ModelDownloadingErrorGrasshopper;
const Content = styled_components_1.default.div `
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.brandedBlack};
`;
const ConnectionErrorIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin-bottom: 20px;
  width: 150px;
  height: 150px;

  ${ui_1.deviceMainScreenLandscape.tablet `
    display: none;
  `}
`;
const Title = styled_components_1.default.div `
  font-size: 25px;
  color: ${({ theme }) => theme.text};
`;
const SubTitle = styled_components_1.default.div `
  line-height: 32px;
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
  color: ${({ theme }) => theme.text};
  max-width: 80%;
`;
const ButtonContainer = styled_components_1.default.div `
  max-width: 480px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
`;
const RetryButton = (0, styled_components_1.default)(ui_1.PrimaryButton) `
  margin-top: 72px;
  border-radius: 4px;
  color: ${({ theme }) => theme.userOnboarding.primaryButton.enabled.text};

  ${ui_1.deviceMainScreen.mobile `
  margin-top: 0px;
  `}
`;
